export const SCROLLABLE_SELECT_MENU_PROPS = Object.freeze({
  MenuListProps: Object.freeze({
    dense: true,
    sx: Object.freeze({ maxHeight: 320, overflowY: 'auto', scrollbarWidth: 'thin' }),
  }),
  PaperProps: Object.freeze({
    sx: Object.freeze({
      maxHeight: 320,
      overflowY: 'auto',
      scrollbarWidth: 'thin',
    }),
  }),
});

